<template>
  <section id="services" class="services sections-bg">
    <div class="pdv-bg"></div>
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-header">
        <h2>PDV</h2>
        <p>Central de atendimento ao cliente</p>
      </div>

      <div class="row gy-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">

        <div @click="goto('pdv.call')"  class="col-lg-3 col-md-4">
          <div class="service-item  position-relative">
            <div class="icon">
              <i class="fa fa-keyboard-o" aria-hidden="true"></i>
            </div>

            <h3>Atendimento</h3>
            <p>Registre aqui os atendimentos realizados pelo seu cliente.</p>
            <span class="readmore">Acessar<i class="bi bi-arrow-right"></i></span>
          </div>
        </div><!-- End Service Item -->

        <div @click="goto('pdv.report')" class="col-lg-3 col-md-4">
          <div class="service-item position-relative">
            <div class="icon">
              <i class="fa fa-file-excel-o fa-3x" aria-hidden="true"></i>
            </div>
            <h3>Relatórios</h3>
            <p>Extraia relatórios e dados dos atendimentos realizados na sua licença.</p>
            <span class="readmore">Acessar<i class="bi bi-arrow-right"></i></span>
          </div>
        </div><!-- End Service Item -->

        <div @click="goto('pdv.timeline')" class="col-lg-3 col-md-4">
          <div class="service-item position-relative">
            <div class="icon">
              <i class="fa fa-bars fa-3x" aria-hidden="true"></i>
            </div>
            <h3>Timeline</h3>
            <p>Acompanhe tudo que aconteceu com o caixa ao longo do dia</p>
            <span class="readmore">Acessar<i class="bi bi-arrow-right"></i></span>
          </div>
        </div><!-- End Service Item -->
        <div @click="goto('prepost.add')" class="col-lg-3 col-md-4">
          <div class="service-item position-relative">
            <div class="icon">
              <i class="fa fa-bookmark fa-3x" aria-hidden="true"></i>
            </div>
            <h3>Postagem</h3>
            <p>Crie uma postagem individual para o seu cliente</p>
            <span class="readmore">Acessar<i class="bi bi-arrow-right"></i></span>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "PdvMain",
  methods: {
    goto(name) {
      this.$router.replace({
        name: name,
      })
    }
  }
};
</script>

<style>
.btn-card {
  width: 180px;
  height: 100px;
}

.icon-large {
  height: 40px;
}

.sections-bg {
  background-color: #f6f6f6;
}

.section-header {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
}

.section-header h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.section-header h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--color-primary);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.section-header p {
  margin-bottom: 0;
  color: #6f6f6f;
}

.services .service-item {
  padding: 40px;
  background: #fff;
  height: 100%;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.services .service-item .icon {
  width: 48px;
  height: 48px;
  position: relative;
  margin-bottom: 50px;
}

.services .service-item .icon i {
  font-size: 56px;
  transition: ease-in-out 0.3s;
  z-index: 2;
  position: relative;
}

.services .service-item h3 {
  color: var(--color-default);
  font-weight: 700;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  font-size: 22px;
  position: relative;
  display: inline-block;
  border-bottom: 4px solid #eeeeee;
  transition: 0.3s;
}

.services .service-item p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

.services .service-item .readmore {
  margin-top: 15px;
  display: inline-block;
  color: var(--color-primary);
}

.services .service-item:hover .icon:before {
  background: #00b6a1;
}

.services .service-item:hover h3 {
  border-color: var(--color-primary);
}

.pdv-bg {
  pointer-events: none;
  height: 88%;
  width: 98%;
  position: absolute;
  background: url('../../assets/pdv.jpg') no-repeat center center fixed !important;
  background-size: cover !important;
  background-blend-mode: overlay;
  opacity: 0.1;
}
</style>